<template>
    <div class="form">
        <Form
            ref="info"
            :model="info"
            :rules="ruleValidate"
            :label-width="100"
            :viewonly="isView"
        >
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="园区/社区" prop="parkId">
                        <Select
                            v-model="info.parkId"
                            transfer
                            :disabled="isAdd"
                        >
                            <Option
                                v-for="item in parkList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.parkName }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="楼栋号" prop="floorName">
                        <Input v-model="info.floorName" placeholder disabled>
                            <span slot="append">栋</span>
                        </Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="房间号" prop="houseNum">
                        <input-number
                            v-model="info.houseNum"
                            placeholder
                            :allowDecimal="false"
                            disabled
                        ></input-number>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="房间代码" prop="houseNo">
                        <Input
                            v-model="info.houseNo"
                            placeholder
                            disabled
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="手机号" prop="cusMobile">
                        <Input
                            v-model="info.cusMobile"
                            placeholder
                            @on-change="onCusMobileSearch"
                        ></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="cusType" label="租客身份">
                        <check-tag-group
                            v-model="cusType"
                            style="display: inline-block"
                            color="primary"
                            @on-change="onCusTypeChange"
                        >
                            <check-tag
                                v-for="item in dict.cusType.toList()"
                                :name="item.id"
                                :key="item.id"
                                >{{ item.text }}</check-tag
                            >
                        </check-tag-group>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="cusUser" label="租客姓名">
                        <Input v-model="info.cusUser" />
                    </FormItem>
                </Col>
                <Col v-if="info.cusType === CUS_TYPE.company" span="12">
                    <FormItem prop="comName" label="单位名称">
                        <Input v-model="info.comName" placeholder></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="预订金额" prop="resAmount">
                        <input-number v-model="info.resAmount" placeholder>
                            <span slot="append">元</span>
                        </input-number>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="最晚签约日" prop="signDate">
                        <DatePicker
                            type="date"
                            placeholder
                            v-model="signDate"
                            transfer
                        ></DatePicker>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="收款状态" prop="receiveStatus">
                        <Select
                            v-model="info.receiveStatus"
                            transfer
                            :viewonly="!isUnpay"
                            @on-change="onReceiveStatusChange"
                        >
                            <Option
                                v-for="item in this.dict.receiveStatus.toList()"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.text }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
                <Col v-if="isReceived" span="12">
                    <FormItem label="收款日期" prop="receiveDate">
                        <DatePicker
                            v-model="receiveDate"
                            type="datetime"
                            placeholder
                            transfer
                            :viewonly="!isUnpay"
                        ></DatePicker>
                    </FormItem>
                </Col>
            </Row>
            <Row v-if="isReceived" :gutter="20">
                <Col span="12">
                    <FormItem label="支付方式" prop="payType">
                        <Select
                            v-model="info.payType"
                            transfer
                            :viewonly="!isUnpay"
                        >
                            <Option
                                v-for="item in cusPayTypeList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.text }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row v-if="isReceived" :gutter="20">
                <Col span="24">
                    <FormItem label="备注" prop="remark">
                        <Input
                            v-model="info.remark"
                            type="textarea"
                            placeholder="0/1000"
                            :rows="4"
                            :viewonly="!isUnpay"
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12"> </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import Dict from '_u/dict'
import Enum from '_u/enum'
import { ymd, ymdL, toDate, deepCopy } from '_u/helper'
import { tel } from '_u/validate'
import { multiply } from '@/views/common/u-contract'

import { assetsBookAdd, assetsBookUpdate, assetsBookView } from '@/api/assets'
import { assetsParkRootList } from '@/api/configuration'
import { queryCusSimpleVtwo } from '@/api/customer'

import RentMode from '_vc/fields/rent-mode'
import RoomConfig from '_vc/fields/room-config'
import SeDatePicker from '_vc/fields/se-date-picker'
import BookCode from './book-code'

const CUS_TYPE = Enum.get('CUS_TYPE'),
    CRED_TYPE = Enum.get('CRED_TYPE')

export default {
    name: 'BookForm',
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
        room: {
            type: Object,
            default() {
                return {
                    houseNum: '',
                    houseNo: '',
                    parkId: '',
                    floorName: '',
                    id: '',
                }
            },
        },
    },
    components: { RentMode, RoomConfig, SeDatePicker, BookCode },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            info: {
                id: this.id,
                parkId: this.room.parkId, // 园区/社区
                floorName: this.room.floorName, //  楼栋
                floorId: this.room.floorId, // 楼栋id
                houseNum: this.room.houseNum, //房间号
                houseNo: this.room.houseNo, //  房间代码
                houseId: this.room.id, // 房间id
                billId: '', // 账单id
                cusType: CUS_TYPE.personal, // 客户类型
                cusId: '', // 预订人编号
                cusUser: '', // 预订人姓名
                comName: '', // 单位名称
                cusMobile: '', // 预订人手机号
                credType: CRED_TYPE.idCard,
                credNo: '',
                resAmount: '', // 预订金额
                receiveStatus: '1', // 收款状态
                signDate: '', // 最晚签约日
                receiveDate: new Date(), //收款日期
                startDate: '', // 约定租期开始日期
                endDate: '', // 预订租期结束日期
                rent: 0, // 租金
                deposit: 0, // 押金
                rentPayMethod: '', // 交租方式(租金)
                depositPayMethod: '', // 交租方式(押金)
                reserveStatus: '1', // 预订状态
                payType: '', // 支付方式
                remark: '',
                ver: 1,
            },
            parkList: [], // 园区列表
            rentMode: '', //交租方式
            customerList: [], // 客户列表
            rent: '', // 押金
            deposit: '', // 押金
            addRooms: 0,
            leaseDate: {}, //约定租期
            dict: {
                cusType: Dict.NULL,
                parkType: Dict.NULL,
                decorationType: Dict.NULL,
                receiveStatus: Dict.NULL, //收款状态
                payType: Dict.NULL,
            },
            modal: {
                showCreateQrcode: false, // 显示二维码
            },
            CUS_TYPE,
            isUnpay: true, // 未收款
        }
    },
    computed: {
        // 是否新增
        isAdd() {
            return this.id === ''
        },
        // 是否查看
        isView() {
            return this.id !== ''
        },
        // 是否已收款
        isReceived() {
            return this.info.receiveStatus == '2'
        },
        // 校验规则
        ruleValidate() {
            var rules = {
                cusMobile: [
                    { required: true, message: '手机号必填' },
                    { validator: tel, message: '手机号格式不正确' },
                ],
                resAmount: [{ required: true, message: '预定金额必填' }],
            }
            // 个人
            if (this.info.cusType === CUS_TYPE.personal) {
                _.assign(rules, {
                    cusUser: [{ required: true, message: '租客姓名必填' }],
                })
            }
            // 单位
            if (this.info.cusType === CUS_TYPE.company) {
                _.assign(rules, {
                    comName: [{ required: true, message: '单位名称必填' }],
                })
            }
            // 已收款
            if (this.info.receiveStatus === '2') {
                _.assign(rules, {
                    receiveDate: [{ required: true, message: '收款日期必填' }],
                    payType: [{ required: true, message: '支付方式必填' }],
                })
            }

            return rules
        },
        // 房源信息
        houseName() {
            return this.room.parkName + this.room.floorName + this.room.houseNum
        },
        signDate: {
            get() {
                return this.info.signDate
                    ? toDate(this.info.signDate, 'YYYY-MM-DD')
                    : ''
            },
            set(val) {
                this.info.signDate = ymd(val)
            },
        },
        receiveDate: {
            get() {
                return this.info.receiveDate
                    ? toDate(this.info.receiveDate)
                    : ''
            },
            set(val) {
                this.info.receiveDate = ymdL(val)
            },
        },
        // 客户身份
        cusType: {
            get() {
                return this.info.cusType ? this.info.cusType.split(',') : []
            },
            set(val) {
                this.info.cusType = val.join(',')
            },
        },
        cusPayTypeList() {
            return this.dict.payType.toList()
        },
    },
    methods: {
        fetch() {
            if (this.id) {
                return assetsBookView(this.id)
            } else {
                return Promise.resolve()
            }
        },
        // 交租方式更改
        changeRentMode(val) {
            this.info.depositPayMethod = val.depositPayMethod
            this.info.rentPayMethod = val.rentPayMethod
            this.info.deposit = val.depositPayMethod * this.info.rent
        },
        closeCreateQrcode() {
            this.modal.showCreateQrcode = false
        },
        // 手机号客户搜索
        onCusMobileSearch(e) {
            var val = e.target.value
            // 至少11位
            if (!isNaN(val) && val.length >= 11) {
                queryCusSimpleVtwo({ cusMobile: val }).then((res) => {
                    var list = res.data?.list || []
                    //如果只获取到一个，则自动选中，并填充其它信息;
                    if (list.length === 1) {
                        this.customerList = list
                        this.setCustomer(val)
                    }
                })
            }
        },
        // 切换客户类型
        onCusTypeChange([val]) {
            if (val === CUS_TYPE.personal) {
                this.info.comName = ''
            }
            // clear error
            this.$refs.info.resetValidation()
        },
        // 证件类型切换
        onCardTypeChange(val) {
            this.info.credType = val.credType
            this.info.credNo = val.credNo
        },
        // 收款状态切换
        onReceiveStatusChange(val) {
            this.setBtns()
        },
        // 设置客户信息
        setCustomer(mobile) {
            var customer = this.customerList.find((v) => v.cusMobile == mobile)
            if (customer) {
                this.info.cusBaseId = customer.cusBaseId
                this.info.cusMobile = customer.cusMobile
                this.info.cusType = customer.cusType || CUS_TYPE.personal
                this.info.cusUser = customer.cusName || ''
                this.info.comName = customer.comName || ''
            }
        },
        // 设置按钮
        setBtns() {
            // 按钮配置
            var btns = [{ type: 'default', text: '取消', name: 'cancel' }]

            if (
                this.$can('update') &&
                (this.isAdd ||
                    (this.isUnpay && this.info.receiveStatus === '2'))
            ) {
                btns.unshift({
                    type: 'primary',
                    name: 'confirm',
                    text: '确定',
                })
            }
            this.$modal.updateBtns(btns)
        },
    },
    watch: {
        'info.rent'(val, oldVal) {
            if (this.deposit && this.info.rent == this.rent) {
                this.info.deposit = this.deposit
            }
            if (val != oldVal && this.info.depositPayMethod) {
                this.info.deposit = this.info.depositPayMethod * val
            }
        },
        'info.depositPayMethod'(val, oldVal) {
            if (val === '4') {
                this.info.deposit = ''
            } else if (val != oldVal && this.info.rent) {
                this.info.deposit = this.info.rent * val
            }
        },
    },
    mounted() {
        var $info = this.$refs.info

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([
                this.fetch(),
                assetsParkRootList(),
                Dict.get([
                    'cus_type',
                    'park_type',
                    'decoration_type',
                    'receive_status',
                    'pay_type',
                ]),
            ])
                .then((args) => {
                    var [view, park, dictGroup] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    if (view) {
                        var viewData = view.data.entity
                        // 实体数据

                        if (viewData.entity) viewData = viewData.entity
                        viewData.resAmount /= 100
                        viewData.rent /= 100
                        viewData.deposit /= 100
                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = viewData[name])
                        )
                        this.leaseDate = {
                            startDate: viewData.startDate,
                            endDate: viewData.endDate,
                        }
                        this.rentMode = {
                            depositPayMethod: viewData.depositPayMethod,
                            rentPayMethod: viewData.rentPayMethod,
                        }
                        this.list = viewData.children
                        this.rent = viewData.rent
                        this.deposit = viewData.deposit
                        this.isUnpay = viewData.receiveStatus !== '2' // 未收款
                        if (this.isUnpay) {
                            this.receiveDate = new Date()
                        }
                    }
                    this.parkList = park.data.list
                    this.setBtns()
                })
                .finally(() => {
                    this.info.rent = this.rent
                    this.info.deposit = this.deposit
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    const formData = deepCopy(this.info)
                    formData.resAmount = multiply(formData.resAmount)
                    formData.rent = multiply(formData.rent)
                    formData.deposit = multiply(formData.deposit)
                    const data = this.$refs.info.populateData()
                    formData.startDate = data.startDate
                    formData.endDate = data.endDate
                    formData.signDate = data.signDate
                    formData.receiveDate = data.receiveDate
                    if (this.id) {
                        return assetsBookUpdate(formData)
                    } else {
                        return assetsBookAdd(formData)
                    }
                })
                .then((res) => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>
<style lang="less" scoped></style>
